import { render, staticRenderFns } from "./UserAvatarButton.vue?vue&type=template&id=ca4996d2"
import script from "./UserAvatarButton.vue?vue&type=script&lang=js"
export * from "./UserAvatarButton.vue?vue&type=script&lang=js"
import style0 from "./UserAvatarButton.vue?vue&type=style&index=0&id=ca4996d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports